import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { MDBBtn } from "mdbreact";
import { Beat } from "../../../../redux/reducers/spinner";
import { cleanInput } from "../../../../redux/helpers";
import { adminActions } from "../../../../redux/actions";
import PrimaryLoader from "../../../includes/Loaders/PrimaryLoader";

export default function ApplicationSettings() {
  const dispatch = useDispatch();
  const { settings, updatingSettings, loadingSettings } = useSelector(
    (state) => state.admin
  );

  const [data, setData] = useState({
    pay_stack_payment_status: settings?.pay_stack_payment_status,
    flutter_wave_payment_status: settings?.flutter_wave_payment_status,
    ogwugo_payment_status: settings?.ogwugo_payment_status,
    automatic_assignment: settings?.automatic_assignment,
    platform_charges: settings?.platform_charges,
  });

  useEffect(() => {
    dispatch(adminActions.getApplicationSettings());
  }, [dispatch]);

  const handleChange = (e) => {
    e.preventDefault();
    const { name, value } = e.target;
    if (name === "service_fee_percentage") {
      setData((prev) => ({
        ...prev,
        platform_charges: {
          ...prev["platform_charges"],
          service_fee: {
            ...prev.platform_charges.service_fee,
            percentage: value,
          },
        },
      }));
    } else if (name === "service_fee_limit") {
      setData((prev) => ({
        ...prev,
        platform_charges: {
          ...prev["platform_charges"],
          service_fee: {
            ...prev.platform_charges.service_fee,
            limit: value,
          },
        },
      }));
    } else if (name === "service_fee_status") {
      console.log("kfkf");
      setData((prev) => ({
        ...prev,
        platform_charges: {
          ...prev["platform_charges"],
          service_fee: {
            ...prev.platform_charges.service_fee,
            status: value,
          },
        },
      }));
    } else {
      setData({ ...data, [name]: value });
    }
  };

  const handleUpdate = async () => {
    cleanInput(data);
    const response = dispatch(
      adminActions.updateApplicationSettings({ ...data })
    );
    if (response.status === "success") {
      dispatch(adminActions.getApplicationSettings());
    }
  };

  return (
    <>
      {loadingSettings ? (
        <PrimaryLoader />
      ) : (
        <>
          <div className="w-100 mx-auto">
            <div className="mx-auto bg-white dark:bg-[#121212] sm:w-[630px] w-full mt-10 sm:mt-0 sm:border p-6 sm:border-gray-200 dark:border-none">
              <div className="border-b-2 dark:border-[#505050] py-4 mb-6">
                <p className=" text-base font-medium text-gray-800 dark:text-white flex justify-center ">
                  Update Application Settings
                </p>
              </div>

              <form>
                <div className=" sm:px-10 mb-10">
                  <div className={"form-group col-md-12 mb-4"}>
                    <label htmlFor="pay_stack_payment_status">
                      Paystack Payment Method
                    </label>
                    <select
                      className="form-control"
                      name="pay_stack_payment_status"
                      value={settings?.pay_stack_payment_status}
                      onChange={handleChange}
                    >
                      <option>Select option</option>
                      <option value={"available"}>Available</option>
                      <option value={"unavailable"}>Unavailable</option>
                    </select>
                  </div>

                  <div className={"form-group col-md-12 mb-4"}>
                    <label htmlFor="ogwugo_payment_status">
                      Ogwugo Payment Method
                    </label>
                    <select
                      className="form-control"
                      name="ogwugo_payment_status"
                      value={settings?.ogwugo_payment_status}
                      onChange={handleChange}
                    >
                      <option>Select option</option>
                      <option value={"available"}>Available</option>
                      <option value={"unavailable"}>Unavailable</option>
                    </select>
                  </div>

                  <div className={"form-group col-md-12 mb-4"}>
                    <label htmlFor="flutter_wave_payment_status">
                      Flutterwave Payment Method
                    </label>
                    <select
                      className="form-control"
                      name="flutter_wave_payment_status"
                      value={settings?.flutter_wave_payment_status}
                      onChange={handleChange}
                    >
                      <option>Select option</option>
                      <option value={"available"}>Available</option>
                      <option value={"unavailable"}>Unavailable</option>
                    </select>
                  </div>

                  <div className="grid sm:grid-cols-2 sm:gap-4">
                    <div className={"form-group col-md-12 mb-4"}>
                      <label htmlFor="service_fee_percentage">
                        Service Fee Percentage
                      </label>
                      <input
                        type="text"
                        className="form-control"
                        name="service_fee_percentage"
                        onChange={handleChange}
                        value={
                          settings?.platform_charges?.service_fee?.percentage
                        }
                        placeholder={"0.0"}
                      />
                    </div>

                    <div className={"form-group col-md-12 mb-4"}>
                      <label htmlFor="service_fee_limit">
                        Service Fee Limit
                      </label>
                      <input
                        type="text"
                        className="form-control"
                        name="service_fee_limit"
                        onChange={handleChange}
                        value={settings?.platform_charges?.service_fee?.limit}
                        placeholder={"0"}
                      />
                    </div>
                  </div>

                  <div className={"form-group col-md-12 mb-4"}>
                    <label htmlFor="service_fee_status">
                      Service Fee Status
                    </label>
                    <select
                      className="form-control"
                      name="service_fee_status"
                      value={settings?.platform_charges?.service_fee?.status}
                      onChange={handleChange}
                    >
                      <option>Select option</option>
                      <option value={"available"}>Available</option>
                      <option value={"unavailable"}>Unavailable</option>
                    </select>
                  </div>
                </div>
              </form>
            </div>
          </div>
          <div className="flex justify-center mx-auto">
            <MDBBtn color="primary" type="button" onClick={handleUpdate}>
              {updatingSettings ? (
                <Beat loading={updatingSettings} />
              ) : (
                "Update Settings"
              )}
            </MDBBtn>
          </div>
        </>
      )}
    </>
  );
}
